import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import {Subject} from "rxjs";

@Component({
  selector: 'app-call-transcript',
  templateUrl: './call-transcript.component.html',
    styleUrls: ['./call-transcript.component.scss'],
})
export class CallTranscriptComponent implements OnInit {

    public onClose: Subject<any>;
    transcriptData: string[] = [];
    data: any;

    constructor(public bsModalRef: BsModalRef,) { }

  ngOnInit() {
      this.transcriptData = this.data.split('\n').slice(0, -1);
  }

    closePanel() {
        this.bsModalRef.hide();
        if (this.onClose) {
            this.onClose.next('close');
            this.onClose.complete();
        }
    }

}
